require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./saying-o-is-me.json") })
        }
      }, "path---saying-o-is-me");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---saying-o-is-me!./.cache/json/saying-o-is-me.json
// module id = 548
// module chunks = 231608221292675